import { render, staticRenderFns } from "./productCard.vue?vue&type=template&id=907539a4&scoped=true"
import script from "./productCard.vue?vue&type=script&lang=js"
export * from "./productCard.vue?vue&type=script&lang=js"
import style0 from "./productCard.vue?vue&type=style&index=0&id=907539a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907539a4",
  null
  
)

export default component.exports